import React, { useState, useEffect } from "react";
// routes
import { AuthRouter, Router } from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
import "./Assets/css/style.css";
// components
import ScrollToTop from "./components/ScrollToTop";
import { BaseOptionChartStyle } from "./components/charts/BaseOptionChart";

// ----------------------------------------------------------------------

export default function App() {
  const [user, setUserData] = useState(null);

  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const restoreUser = async () => {
    const users = await localStorage.getItem("userData");
    if (users != null) {
      setUserData(users);
    }
  };

  useEffect(() => {
    restoreUser();
  }, []);

  return (
    <>
      <ThemeConfig>
        <ScrollToTop />
        <GlobalStyles />
        <BaseOptionChartStyle />
        {user == null ? <AuthRouter /> : <Router />}
      </ThemeConfig>
    </>
  );
}
